/**
 * Pure helpers for casa central / sucursales, shared by beauty, canchas and
 * reservas. The back returns sucursales in each rubro's listing-item shape.
 */

const BASE_BY_KIND = { beauty: "/beauty", canchas: "/canchas", reservas: "/reservas" };

/** Public landing path of a venue; like the listing cards, it prefers the slug over the id. */
export const sucursalPath = (kind, item) => {
  const base = BASE_BY_KIND[kind] || "";
  const ref = item?.slug || item?._id;
  return `${base}/${ref}`;
};

/** Where the top "back" goes: the casa central on a sucursal landing, else the listing. */
export const backTarget = (kind, casaCentral) =>
  casaCentral
    ? { path: sucursalPath(kind, casaCentral), label: `Volver a ${casaCentral.name}` }
    : { path: BASE_BY_KIND[kind] || "/", label: "Volver a la búsqueda" };

/** "1 sucursal" / "N sucursales"; empty when there are none. */
export const sucursalesLabel = (count) => {
  const n = Number(count) || 0;
  if (n <= 0) return "";
  return n === 1 ? "1 sucursal" : `${n} sucursales`;
};

export const SUCURSALES_COPY = {
  beauty: "Elegí dónde querés atenderte. Cada sucursal tiene sus propios servicios, profesionales y horarios.",
  canchas: "Elegí dónde querés jugar. Cada sucursal tiene sus propias canchas y horarios.",
  reservas: "Elegí dónde querés reservar. Cada sucursal tiene sus propias mesas y horarios.",
};
